/**
 * Why "Center on my location" found nothing (live walk 2026-10-19: the button silently did nothing).
 * Browsers only expose geolocation on a secure origin (https, or localhost), so a phone on a plain-http
 * LAN address is refused without any prompt. Otherwise it is the site's location permission.
 */
export function locationUnavailableMessage(isSecureContext: boolean): string {
  return isSecureContext
    ? "We couldn't get your location. Allow location for this site in your browser settings."
    : "Location needs a secure (https) connection, so this page can't use it."
}
